import { toast } from '@heroui/react';

import {
  handleError,
  type ErrorCode,
  type ErrorInfo,
  isValidationError,
} from '@hs/shared';

/**
 * ✅ 处理tRPC错误的便捷函数（带UI）
 *
 * ⚠️ 重要：此函数只处理验证错误（UNPROCESSABLE_CONTENT）
 * 其他错误（网络错误、服务器错误等）由全局错误处理统一处理
 */
export function handleTRPCError(
  error: unknown,
  options?: {
    customMessages?: Partial<Record<ErrorCode, string>>;
    onError?: (errorInfo: ErrorInfo) => void;
  }
): void {
  const errorInfo = handleError(error, {
    customMessages: options?.customMessages,
  });

  if (errorInfo.code === 'UNPROCESSABLE_CONTENT' && errorInfo.zodError) {
    const validationMessages = errorInfo.zodError.issues
      .map((issue) => {
        const path = issue.path.length > 0 ? issue.path.join('.') : '参数';
        return `${path}: ${issue.message}`;
      })
      .join('\n');

    toast.danger('请求参数错误', {
      description: validationMessages,
      timeout: 5000,
    });
  }

  options?.onError?.(errorInfo);

  if (import.meta.env.DEV) {
    console.group(`❌ Error [${errorInfo.code}]`);
    console.error('Message:', errorInfo.message);
    if (errorInfo.zodError) console.error('Validation Issues:', errorInfo.zodError.issues);
    console.groupEnd();
  }
}

export { handleError, isValidationError, type ErrorCode, type ErrorInfo } from '@hs/shared';
